var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_customize_FILL0_wght400_GRAD0_opsz24",
    d: "M120-840h14.222v14.222H120Zm3.556,3.556v0ZM137.778-840H152v14.222H137.778Zm3.556,3.556v0ZM120-822.222h14.222V-808H120Zm3.556,3.556v0Zm19.556-3.556h3.556v5.333H152v3.556h-5.333V-808h-3.556v-5.333h-5.333v-3.556h5.333Zm-1.778-14.222v7.111h7.111v-7.111Zm-17.778,0v7.111h7.111v-7.111Zm0,17.778v7.111h7.111v-7.111Z",
    transform: "translate(-120 840)",
    fill: "#0c6972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomize);
export default __webpack_public_path__ + "static/media/dashboard-customize.38b6983f7465d4ebd18647670535f547.svg";
export { ForwardRef as ReactComponent };